<script setup lang="ts">
import { defineProps, defineEmits } from "vue";
import QuestionnareButtonColor from "../parts/QuestionnareButtonColor.vue";
import QuestionnaireButtonPrev from "../parts/QuestionnaireButtonPrev.vue";
import QuestionnaireOutline from "../parts/QuestionnaireOutline.vue";

type Props = {
  appointmentCompletedButtonText: string;
  dataIsMissingButtonText: string;
  apointmentFailedButtonText: string;
  prevButtonText: string;
};

defineProps<Props>();

type Emits = {
  (event: "onSubmit", value: boolean, message: string): void;
  (event: "onAbnahmePassed"): void;
  (event: "onDataMissing"): void;
  (event: "onAbnahmeFailed"): void;
  (event: "onStepBack"): void;
};
const emits = defineEmits<Emits>();
</script>

<template>
  <div class="mt-[45px]">
    <div class="w-full mb-[45px] px-8">
      <h3
        class="text-xl leading-[32px] tracking-[0.01rem] text-primary-text-color font-semibold pb-2"
      >
        What is the outcome of Abnahme?
      </h3>
      <div class="w-full flex flex-col items-start gap-3">
        <div class="w-full">
          <QuestionnareButtonColor
            @click="$emit('onAbnahmePassed')"
            :button-text="appointmentCompletedButtonText"
          />
        </div>
        <div class="w-full">
          <QuestionnaireOutline
            @click="$emit('onDataMissing')"
            :button-text="dataIsMissingButtonText"
          />
        </div>
        <div class="w-full">
          <QuestionnaireOutline
            @click="$emit('onAbnahmeFailed')"
            :button-text="apointmentFailedButtonText"
          />
        </div>
      </div>
    </div>
    <div
      class="w-full flex items-center justify-between pt-3 border-t border-black/15"
    >
      <div class="w-full h-full">
        <QuestionnaireButtonPrev
          @click="$emit('onStepBack')"
          :button-text="prevButtonText"
        />
      </div>
    </div>
  </div>
</template>
